import React, { ForwardedRef, forwardRef } from "react";
import clxs from "./basic-info-detail.module.css";
import PropertyRatings from "../../PropertyDetail/LohonoLayout/PropertyRatings";
import useClx from "../../../hooks/use-clx";
import BLUE_PIN_ICON from "../../../assets/icons/blue_pin_drop.svg";
import Specification from "../../PropertyDetail/Specification";

interface BasicInfoDetailProps {
  className?: string;
  ratingsCount?: number;
  averageRatings?: number;
  reviewRef?: React.RefObject<HTMLDivElement>;
  googleMapLink?: string;
  address?: string;
  upcoming?: boolean;
  villaName?: string;
  viewLayout: string;
  accommodation: string;
  bathCount: number;
  bedroomCount: number;
  isMultiConfig?: boolean;
  configs: PropertyConfig[];
  poolCount: number;
  proximity?: string;
}
  const BasicInfoDetail = forwardRef(
    function BasicInfoDetailCore(
      props: BasicInfoDetailProps,
      ref: ForwardedRef<HTMLDivElement>,
    ) {
  const {
      ratingsCount,
      averageRatings,
      reviewRef,
      googleMapLink,
      address,
      upcoming,
      villaName,
      viewLayout,
      accommodation,
      bathCount,
      bedroomCount,
      isMultiConfig,
      configs,
      poolCount,
      proximity,
      className,
    } = props,
    ccx = useClx(clxs.container, className);

  return (
    <div 
      className={ccx}
      ref={ref}
    >
      {ratingsCount && averageRatings ? (
        // Check if both ratings_count and average_ratings are truthy
        // If true, render the PropertyRatings component
        <PropertyRatings
          className={clxs.clusterRatings}
          ratings_count={ratingsCount}
          average_ratings={averageRatings}
          reviewRef={reviewRef}
        />
      ) : null}
      
      <div>
        <h1 className={clxs.title}>
          {villaName}
          {upcoming && <span className={clxs.upcoming}>Coming soon</span>}
        </h1>
        
        <div className={clxs.subtitle}>
          {address}
          {googleMapLink && (
            <a
              href={googleMapLink}
              className={clxs.mapLink}
              target="_blank"
              rel="noopener noreferrer"
              title="View on Map"
            >
              View on Map
            </a>
          )}
        </div>
      </div>

      <Specification
        viewLayout={viewLayout}
        accommodation={accommodation}
        bathCount={bathCount}
        bedroomCount={bedroomCount}
        configs={isMultiConfig ? [] : configs}
        poolCount={poolCount}
        className={clxs.specification}
      />

      {proximity ? 
      <div className={clxs.withinDistanceContainer}>
        <img
          src={BLUE_PIN_ICON}
          alt="star"
          className={clxs.pinIcon}
        />
        <div className={clxs.withinDistance}>Within {proximity}</div>
      </div>: null}
    </div>
  );
})

export default BasicInfoDetail;
